import { ItemVM } from 'shell/view-models/item';

export enum STATES_NOTIFICATIONS {
  ID_STATE_DA_APPROVARE = '1',
  ID_STATE_APPROVATO = '2',
  ID_STATE_RIFIUTATA = '3',
  ID_STATE_STATOINFORMATIVO = '4',
}

export const LIST_STATES: Array<ItemVM> = [
  {
    id: STATES_NOTIFICATIONS.ID_STATE_DA_APPROVARE,
    value: 'Da approvare',
  },
  {
    id: STATES_NOTIFICATIONS.ID_STATE_APPROVATO,
    value: 'Approvata',
  },
  {
    id: STATES_NOTIFICATIONS.ID_STATE_RIFIUTATA,
    value: 'Rifiutata',
  },
  {
    id: STATES_NOTIFICATIONS.ID_STATE_STATOINFORMATIVO,
    value: 'Statoinformativo',
  },
];

export const getValueStateNotification = (id?: string): string => {
  if (!id) {
    return '';
  }

  return LIST_STATES.find((item) => item.id === id)?.value || '';
};
